import styled from "styled-components";
import { fontSizes, lineHeights, rawColors as uiColors, spacing, typographyMixin } from "@magicbi/ui-library";

export const Root = styled.section`
  display: grid;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const Heading = styled.h3`
  margin: 0;
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const List = styled.ul`
  display: grid;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Row = styled.li`
  display: flex;
  align-items: baseline;
  gap: ${spacing[3]};
  min-width: 0;
  padding: ${spacing[2]} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.stroke};

  &:last-child {
    border-bottom: 0;
  }
`;

export const Label = styled.span`
  flex: none;
  width: 6rem;
  ${typographyMixin("caption", 3)}
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["18"]};
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Body = styled.span`
  display: grid;
  flex: 1;
  min-width: 0;
`;

export const Value = styled.span`
  ${typographyMixin("caption", 2)}
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["20"]};
  color: ${uiColors.text.strongEmphasis};
  overflow-wrap: anywhere;
`;

export const Source = styled.span<{ $overridden: boolean }>`
  ${typographyMixin("caption", 3)}
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["18"]};
  color: ${({ theme, $overridden }) => ($overridden ? theme.colors.primary[500] : uiColors.text.mediumEmphasis)};
`;

export const Action = styled.button`
  flex: none;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.primary[500]};

  &:hover {
    text-decoration: underline;
  }
`;
